import AddIcon from "./AddIcon";
import ArrowDownIcon from "./ArrowDownIcon";
import ArrowLeftIcon from "./ArrowLeftIcon";
import ArrowRightIcon from "./ArrowRightIcon";
import AutoTrackIcon from "./AutoTrackIcon";
import BackIcon from "./BackIcon";
import CalendarIcon from "./CalendarIcon";
import ChangeTimeIcon from "./timeslots/ChangeTimeIcon";
import ChromeIcon from "./ChromeIcon";
import CollapseIcon from "./CollapseIcon";
import EditIcon from "./EditIcon";
import FavoriteIcon from "./FavoriteIcon";
import SharedIcon from "./SharedIcon";
import GCalendarIcon from "./GCalendarIcon";
import HourGlassIcon from "./HourGlassIcon";
import JournalIcon from "./timeslots/JournalIcon";
import MenuIcon from "./MenuIcon";
import MoreIcon from "./timeslots/MoreIcon";
import MoreItemsIcon from "./MoreItemsIcon";
import SleepIcon from "./SleepIcon";
import UndoIcon from "./timeslots/UndoIcon";
import ArrowDropdown from "./ArrowDropdown";
import QuestionMarkIcon from "./QuestionMarkIcon";
import HowIcon from "./HowIcon";
import RoutinesIcon from "./RoutinesIcon";
import ManaIcon from "./ManaIcon";
import AppleHealthIcon from "./AppleHealthIcon";
import Snooze from "./Snooze";
import SnoozeLater from "./SnoozeLater";
import SnoozeLaterThisWeek from "./SnoozeLaterThisWeek";
import SnoozeNextWeek from "./SnoozeNextWeek";
import SnoozeTomorrow from "./SnoozeTomorrow";
import Dismiss from "./Dismiss";
import Bell from "./Bell";
import Clock from "./Clock";
import BarChartSwitchViewIcon from "./BarChartSwitchViewIcon";
import PlayStopIcon from "./timer/PlayStopIcon";

const Icons = {
  AddIcon,
  ArrowDown: ArrowDownIcon,
  ArrowDropdown,
  ArrowLeft: ArrowLeftIcon,
  ArrowRight: ArrowRightIcon,
  AutoTrackIcon,
  BarChartSwitchViewIcon,
  Back: BackIcon,
  Calendar: CalendarIcon,
  ChangeTimeIcon,
  ChromeIcon,
  Collapse: CollapseIcon,
  Edit: EditIcon,
  Favorite: FavoriteIcon,
  Shared: SharedIcon,
  AppleHealthIcon,
  GCalendarIcon: GCalendarIcon,
  HourGlassIcon,
  Journal: JournalIcon,
  MenuIcon,
  More: MoreIcon,
  MoreItems: MoreItemsIcon,
  QuestionMarkIcon,
  SleepIcon,
  Undo: UndoIcon,
  HowIcon,
  RoutinesIcon,
  ManaIcon,
  Snooze,
  SnoozeLater,
  SnoozeLaterThisWeek,
  SnoozeNextWeek,
  SnoozeTomorrow,
  Dismiss,
  Bell,
  Clock,
  PlayStopIcon,
};

export default Icons;
